<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/S9ZIN6/tc-custom/9781626815834.jpg?1702083761979" alt="This image is the cover for the book Restoration, Time Trap"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Restoration, Time Trap
      </h1>
      <p class="bookDescription body article font2">
        <b>A time traveler faces his duplicate in 17th-century England in the series from the “masterful” national bestselling author of Lucasfilm’s Alien Chronicles (<i>Extrapolations</i>).</b><br/>  <br/> In his attempt to return to the twenty-sixth century, historian Noel Kedran is transported, alongside his evil twin Leon, to the squalid streets and royal palaces of Restoration England—and into the blazing heart of the Great Fire of London.<br/>  <br/> Amidst the inferno, Noel will distinguish himself as a hero, whose only hope is to get home to his own time. To do so, he will have to outwit the treacherous, equally brilliant Leon.<br/>  <br/> But how can any man hope to outwit himself?<br/>  <br/> “Chester is a world class fantasist.” —<i>The Best Reviews</i><br/><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah Chester
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03566ffd